import React, { FunctionComponent, lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { VIEW_PATH } from '@common/constants'
import { ErrorMessage, LoadingSpinner } from '@common/components'
import { useLanguageInPathName } from '@common/hooks/useLanguageInPathName'
// Import the page views
const Billing = lazy(() => import('./views/Billing'))
const ConfirmationView = lazy(() => import('./views/Confirmation'))

export type ParamTypes = {
    [key: string]: string | undefined
    pathProduct: string
    plan: string
}

export const BuyRoutes: FunctionComponent = () => {
    const { didRedirect } = useLanguageInPathName()

    // If didRedirect was set to true, then don't continue with anything else in this file
    if (didRedirect === true) {
        return null
    }

    return (
        <Suspense fallback={<LoadingSpinner />}>
            <Routes>
                {/* billing main page with customize */}
                <Route path={`/:plan${VIEW_PATH.PATH_CUSTOMIZE}`} element={<Billing step="customize" />} />

                {/* billing main page with checkout */}
                <Route path={`/:plan${VIEW_PATH.PATH_CHECKOUT}`} element={<Billing step="checkout" />} />

                {/* confirmation page page */}
                <Route path={`/:plan${VIEW_PATH.PATH_CONFIRMATION}`} element={<ConfirmationView />} />

                {/* next steps page */}
                {/* <Route path="/:plan/next-steps" element={<NextStepsView />} /> */}

                {/* fallback */}
                <Route
                    path="/*"
                    element={
                        <div style={{ padding: 20, margin: 20 }}>
                            {/* TODO: Find out if we should show an error, redirect to some default page or redirect to the 404 page on goto.com */}
                            <ErrorMessage errorMessage="Uh-oh! The page you are looking for was not found." />
                        </div>
                    }
                />
            </Routes>
        </Suspense>
    )
}
